import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

// Attaches the bearer token to every outgoing admin-app request. This is the
// only place outside a guard or the auth/session service allowed to read the
// session cookie (token-access-confined) — AdminHttpService no longer does.
@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor {
  constructor(private _cookie_service: CookieService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this._cookie_service.get('access_token');
    const authorized_req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next.handle(authorized_req);
  }
}
